import {
  createContext,
  Dispatch,
  FunctionComponent,
  SetStateAction,
  useContext,
} from "react";

type ContextType = {
  languages: string[];
  isCrypto: boolean;
  setIsCrypto: Dispatch<SetStateAction<boolean>>;
};

const context = createContext<ContextType>((undefined as any) as ContextType);

export function useNewLaunchContext() {
  return useContext(context);
}

export const NewLaunchContextProvider: FunctionComponent<ContextType> = ({
  children,
  ...props
}) => {
  return <context.Provider value={props}>{children}</context.Provider>;
};
